"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arkosePublicKey = void 0;
const arkosePublicKey = (arkoseKey, isDev) => {
    if (arkoseKey !== "wwwLogin") {
        throw new Error("Unsupported Arkose Key");
    }
    if (isDev) {
        return "C383A903-0809-41A2-A832-5F7ACC690EA6";
    }
    return "D99D7D11-158A-408C-A6C5-29F2B60EFADE";
};
exports.arkosePublicKey = arkosePublicKey;
//# sourceMappingURL=constants.js.map